import React from 'react';
import PropTypes from 'prop-types';
import { get, isEmpty, trim, size } from 'lodash';
import Anchor from 'common-ui-components/dist/components/Atoms/Anchor';
import { getDefaultSoldTo } from '../../../utils/utils';
import './AccountName.scss';

const AccountName = props => {
  const {
    openSwitchAccountModal,
    labels,
    className,
    userDetails = {},
    soldTo = [],
    pageContent = [],
  } = props;
  const company = get(userDetails, 'company', '');
  const priorityAccount = getDefaultSoldTo(soldTo);
  const { name: customerName } = priorityAccount;
  const accountName = trim(customerName) || trim(company);
  const isShowSwitchAccountLink = size(soldTo) > 1;
  const headerContent =
    pageContent && pageContent.length > 0 ? pageContent.find(item => item.name === 'header') : {};
  const switchAccountLabel = get(labels, 'switchAccountLabel', '');
  const switchAccountLink = get(headerContent, 'switchAccountLink', '#');
  const renderAddress = () => {
    let address = '';
    if (!isEmpty(accountName)) {
      address = accountName;
    }
    return address;
  };
  return (
    <>
      <div
        className={`sold-to-address-container ${className}`}
        data-locator="row sold-to-address-container"
      >
        <div
          className="col-md-12 col-xs-12 sold-to-address-line"
          data-locator="sold-to-address-line"
        >
          {renderAddress()}
        </div>
      </div>
      <div>
        {isShowSwitchAccountLink && (
          <div className="col-md-12 col-xs-12 col-sm-12 switch-account-label">
            <Anchor
              to={switchAccountLink}
              handleLinkClick={openSwitchAccountModal}
              elementLocator="sold-to-address-switch-account-link"
              data-locator="sold-to-address-switch-account-link"
            >
              {switchAccountLabel}
            </Anchor>
          </div>
        )}
      </div>
    </>
  );
};

AccountName.propTypes = {
  className: PropTypes.string,
  labels: PropTypes.objectOf(PropTypes.string),
  userDetails: PropTypes.objectOf(PropTypes.string),
  pageContent: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.bool])
  ),
  soldTo: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.bool])
  ),
  openSwitchAccountModal: PropTypes.func,
};

AccountName.defaultProps = {
  className: '',
  pageContent: [],
  soldTo: [],
  labels: {},
  userDetails: {},
  openSwitchAccountModal: () => {
    /* default openSwitchAccountModal handler */
  },
};

export default AccountName;
